import BaseApi from "./base";

export default class LocationApi extends BaseApi {
  baseName = "location";

  me(options) {
    return this.retrieve(null, { ...options, endpoint: "me" });
  }
}
